import { useState } from "react";
import "./PasswordPage.css";
import { FiEyeOff, FiEye } from "react-icons/fi";
import CustomButton from "../../../components/customButton/CustomButton";
import useChangePassword from "../../../hook/useChangePassword";

const PasswordPage = () => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    touched,
    handleBlur,
    isLoading,
  } = useChangePassword();

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <div className="password-page-container">
      <h6>Change Password</h6>
      <div className="password-page-details">
        <p className="heading-first">
          Please create your password that is at least 8 characters long
        </p>
        <form onSubmit={handleSubmit}>
          <div className="inner-contain">
            <div className="input-bg-cp">
              <h4>Current Password*</h4>
              <div className="password-input-wrapper">
                <input
                  type={showCurrent ? "text" : "password"}
                  name="old_password"
                  value={values.old_password}
                  onChange={handleChange("old_password")}
                  onBlur={handleBlur("old_password")}
                />
                <button
                  type="button"
                  onClick={() => setShowCurrent(!showCurrent)}
                  className="toggle-password-btn"
                >
                  {showCurrent ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
              {touched.old_password && errors.old_password && (
                <span className="error-text">{errors.old_password}</span>
              )}
            </div>
            <div className="input-bg-cp">
              <h4>New Password*</h4>
              <div className="password-input-wrapper">
                <input
                  type={showNew ? "text" : "password"}
                  name="new_password"
                  value={values.new_password}
                  onChange={handleChange("new_password")}
                  onBlur={handleBlur("new_password")}
                />
                <button
                  type="button"
                  onClick={() => setShowNew(!showNew)}
                  className="toggle-password-btn"
                >
                  {showNew ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
              {touched.new_password && errors.new_password && (
                <span className="error-text">{errors.new_password}</span>
              )}
            </div>
            <div className="input-bg-cp">
              <h4>Confirm New Password*</h4>
              <div className="password-input-wrapper">
                <input
                  type={showConfirm ? "text" : "password"}
                  name="confirm_password"
                  value={values.confirm_password || ""}
                  onChange={handleChange("confirm_password")}
                  onBlur={handleBlur("confirm_password")}
                />
                <button
                  type="button"
                  onClick={() => setShowConfirm(!showConfirm)}
                  className="toggle-password-btn"
                >
                  {showConfirm ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>

              {touched.confirm_password && errors.confirm_password && (
                <span className="error-text">{errors.confirm_password}</span>
              )}
            </div>

            <div className="button-container">
              <CustomButton
                customStyles={{
                  width: "150px",
                  height: "40px",
                  marginTop: "0",
                  fontSize: "14px",
                  borderRadius: "5px",
                }}
                title="Save Password"
                loading={isLoading}
                disable={isLoading}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordPage;
